export default __webpack_public_path__ + "static/media/railway.7b9b80a1.jpg";